
import api from "./apiConfig";

const user_service = "user-service/api/v1/user";
const admin_service = "admin-service/api/v1/admin";
const topic_service = "topic-service/api/v1/topics";

// const admin_service = ":8001/admin-service/api/v1/admin";
// const advisor_service = ":8002/advisor-service/api/v1/advisors";
// const appoint_service = ":8003/appointment-service/api/v1/appointments";
// const payment_service = ":8005/payment-service/api/v1/payments";
// const topic_service = ":8006/topic-service/api/v1/topics";
// const user_service = ":8007/user-service/api/v1/user";

const auth = {
  userLogin: (data) => api.post(`${user_service}/login`, data),
  getDashBoardCount: (data) => api.get(`${admin_service}/dashboard`, data),
  getTopicsNotification: (data) => api.post(`${admin_service}/getAdminNotify`, data)
};

const user = {
  getAllusersList: (data) => api.post(`${admin_service}/users/allUsers`, data),
  getUserDetailsById: (data) => api.post(`${admin_service}/users/getUserDetail`, data),
  approveRejectStatus: (data) => api.post(`${admin_service}/user/updateStatus`, data),
};

const report = {
  getAllreportList: (data) => api.post(`${admin_service}/getallReports`, data),
  getReportDetailsById: (id) => api.get(`${admin_service}/getReportById`, { params: { id } }),
}


const advisor = {
  getAlladvisorsList: (data) => api.post(`${admin_service}/advisor/allAdvisors`, data),
  getAdvisorDetailsById: (data) => api.post(`${admin_service}/users/getUserDetail`, data),
  getAdvisoProofById: (advisor_id) => api.get(`${admin_service}/getAdvisorProof`, { params: { advisor_id } }),
  advisorUserChangeStatus: (data) => api.post(`${user_service}/advisorVerifyStatus`, data)
};



const topics = {
  getAllTopicsList: (data) => api.post(`${admin_service}/topics/allTopics`, data),
  getTopicsDetailsById: (id) =>
    api.get(`${topic_service}/getTopicById`, {
      params: { id }

    }),
  getValidateTopicById: (id) => api.get(`${admin_service}/getValidatetopicById`, { params: { id } }),

};


const validateTopics = {
  getValidteTopics: (data) => api.post(`${admin_service}/getApprovalReqTopic`, data),
  rejectTopics: (data) => api.post(`${topic_service}/rejectTopicProof`, data),
  validateTopics: (data) => api.put(`${admin_service}/topics/validateTopic`, data)
}



const globalSetting = {
  getAllGlobalSettings: (data) => api.get(`${admin_service}/getGlobalSetting`, data),
  updateGlobalSettings: (data) => api.post(`${admin_service}/updateGlobalSettings`, data),
}

const refunds = {
  getTransactions: (data) => api.post(`${admin_service}/transactions`, data),
  refundTransaction: (data) => api.post(`payment-service/api/v1/payments/admin-refund`, data),
}

export default {
  auth,
  user,
  advisor,
  topics,
  validateTopics,
  globalSetting,
  report,
  refunds
};
